<div class="kontainer">
  <div class="valg-kontainer" [class.valgt]="skjema.value.enkel">
    <mat-slide-toggle [formControl]="skjema.controls.enkel" data-testid="enkel">
      {{ 'Enkel elektronisk'|translate }}
    </mat-slide-toggle>
    <div class="beskrivelse">{{ 'Bruker signerer med et engangspassord tilsendt på SMS eller e-post'|translate }}</div>
  </div>
  <div class="valg-kontainer" [class.valgt]="skjema.value.avansert">
    <mat-slide-toggle [formControl]="skjema.controls.avansert" data-testid="avansert">
      {{ 'Avansert elektronisk'|translate }}
    </mat-slide-toggle>
    <div class="beskrivelse">{{ 'Bruker signerer med BankID'|translate }}</div>
  </div>
</div>
